<template>
  <q-page class="app-page">
    <div class="wrapper">
      <router-view name="page" v-slot="{ Component }" >
        <component :is="Component" />
      </router-view>
    </div>
  </q-page>
</template>

<script>
export default {
}
</script>

<style scoped lang="scss">
.app-page {
  background: var(--color-light-bg);
  color: var(--color-black);
  padding: 3rem;

  .wrapper {
    max-width: var(--spacing-max-content-width);
    margin: auto;

    min-height: 70vh;
  }
}

@media (max-width: 650px) {
  .app-page {
    padding: 3rem 0;
  }
}
</style>
